import ChannelMessageList from './ChannelMessageList';

export default ChannelMessageList;
